import { param } from "jquery";

export class DistribuidorIndicadoApi {
    async index(filters) {
        try {
            const response = await axios.get('/distribuidores_indicados', {
                params: filters
            });

            return response.data;
        } catch (error) {
            console.error('Error fetching distribuidores indicados:', error);
            throw error;
        }
    }

    async show(id) {
        try {
            const response = await axios.get(`/distribuidores_indicados/${id}`);

            return response.data;
        } catch (error) {
            console.error('Error fetching distribuidor indicado:', error);
            throw error;
        }
    }

    async update(data, id) {
        try {
            const response = await axios.put(`/distribuidores_indicados/${id}`, data);

            return response.data;
        } catch (error) {
            console.error('Error update distribuidor indicado:', error);
            throw error;
        }
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/api/DistribuidorIndicadoApi.js